import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';

export const BREAKDOWN_MESSAGE_TYPE_LOADING_TEST_ID = 'breakdown-message-type-loading';

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
`;

export const BreakdownMessageTypeLoading = () => {
  return (
    <SkeletonContainer data-test={BREAKDOWN_MESSAGE_TYPE_LOADING_TEST_ID}>
      <Skeleton height={304} width={1160} />
    </SkeletonContainer>
  );
};
